import React from "react";
import LoadingSpinner from "./LoadingSpinner";

export default function AppLoading() {
  return (
    <div className="flex h-screen items-center justify-center">
      <LoadingSpinner />
    </div>
  );
}
